import {
  Cryptocurrency,
  SupportedCurrency,
} from '#src/__generated__/globalTypes.ts';

import { isAddress } from './ethereum.ts';
import { isSolanaAddress } from './solana.ts';

export const cryptocurrencyLabels = {
  [Cryptocurrency.WEI]: 'Ethereum',
  [Cryptocurrency.LAMPORT]: 'Solana',
};

export const cryptocurrencySymbols = {
  [Cryptocurrency.WEI]: 'ETH',
  [Cryptocurrency.LAMPORT]: 'SOL',
};

export const placeholderAddresses = {
  [Cryptocurrency.WEI]: '0x0000000000000000000000000000000000000000',
  [Cryptocurrency.LAMPORT]: '11111111111111111111111111111111',
};

export const CRYPTO_SUPPORTED_CURRENCIES: SupportedCurrency[] = [
  SupportedCurrency.WEI,
  SupportedCurrency.LAMPORT,
];

type SupportedCryptocurrency =
  (typeof Cryptocurrency)[keyof typeof Cryptocurrency];

export const isCryptocurrency = (
  value: SupportedCurrency | null | undefined
): value is SupportedCryptocurrency => {
  if (!value) return false;
  return CRYPTO_SUPPORTED_CURRENCIES.includesValue(value);
};

export const isCryptoAddressValid = (
  address: string,
  cryptocurrency: Cryptocurrency
) => {
  if (cryptocurrency === Cryptocurrency.WEI) {
    return isAddress(address);
  }
  if (cryptocurrency === Cryptocurrency.LAMPORT) {
    return isSolanaAddress(address);
  }
  return false;
};
